import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BroadcastService } from '../../services/broadcast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
,  standalone: false})
export class HeaderComponent implements OnChanges {
  @Input() envInfo: any;
  public setEnv:any;
  private subscriptions = new Subscription();
  constructor(private _broadcast: BroadcastService){

  }

  ngOnInit(): void {   
    this.processEnvInfo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['envInfo'] && changes['envInfo'].currentValue) {
      this.processEnvInfo();
    }
  }

  processEnvInfo() {
    if (this.envInfo) {
      this.setEnv = this.envInfo.PUBLIC_LISTINGS_ENV;
      if((this.setEnv =="") || (this.setEnv =="PROD") || (this.setEnv == null))
        this.setEnv = null;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
